import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../Providers/AuthProviders'
import { instructorClasses } from '../../API/class'

function MyClasses() {
    const { user } = useContext(AuthContext)
    const [data, setData] = useState([])

    useEffect(() => {
        instructorClasses(user?.email)
            .then(data => setData(data))
    }, [user])

    return (
        <>
            <p className='text-center font-bold text-5xl tracking-tight pt-10 font-serif dark:text-white'>My Classes</p>
            <div className='max-w-[85%] mx-auto mt-8 pb-16'>
                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-center text-gray-700 uppercase bg-green-100 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    No.
                                </th>
                                <th scope="col" className="px-6 py-3 text-left">
                                    Class name
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Students
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    Status
                                </th>
                                {/* <th scope="col" className="px-6 py-3">
                                    Update
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map((d, i) =>
                                    <tr key={d._id} className="bg-white text-center border-b dark:bg-gray-700 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td className="w-4 p-4">
                                            <div className="flex ps-2 items-center">
                                                {i + 1}
                                            </div>
                                        </td>
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 text-left whitespace-nowrap dark:text-white">
                                            {d.name}
                                        </th>
                                        <td className="px-6 py-4">
                                            {d.enrolled}
                                        </td>
                                        <td className="px-6 py-4">
                                            {d.status}
                                        </td>
                                        {/* <td className="px-6 py-4">
                                            <button type="button" className="text-white bg-emerald-500 hover:bg-emerald-600 focus:outline-none font-medium rounded-full text-sm px-5 py-2.5 text-center">Update</button>
                                        </td> */}
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default MyClasses